import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { IconButton } from "../IconButton/index.js";
import { cn } from "../../utils/cn.js";
import { Tooltip } from "../Tooltip/index.js";
const toolTipClass = 'data-disabled:cursor-not-allowed test cursor-pointer';
const CounterIconButton_CounterIconButton = /*#__PURE__*/ forwardRef(function({ type, ariaLabel, ariaControls, onClick, buttonType, disabled, tooltipProps, iconButtonProps = {}, emphasis }, ref) {
    const { iconName = 'increment' === type ? 'add' : 'remove', size = 'sm', ...restProps } = iconButtonProps;
    const Button = /*#__PURE__*/ jsx(IconButton, {
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        onClick: onClick,
        type: buttonType,
        iconName: iconName,
        size: size,
        emphasis: emphasis,
        disabled: disabled,
        ref: ref,
        ...restProps
    });
    if (tooltipProps?.children) {
        const { className, ...restTooltipProps } = tooltipProps;
        const tooltipEmphasis = 'bold' !== emphasis;
        const toolTipClasses = cn(toolTipClass, className);
        return /*#__PURE__*/ jsx(Tooltip, {
            "data-testid": "tooltip-result",
            ...restTooltipProps,
            emphasis: tooltipEmphasis,
            className: toolTipClasses,
            triggerNode: Button
        });
    }
    return Button;
});
export { CounterIconButton_CounterIconButton as CounterIconButton };
